<template>
    <div class="p-4">
      <l-container class="mb-4">
        <l-container-title
          slot="toolbar"
          :text= "this.$t('aboutDataMap')"
          icon="network-wired"
          color="bg-pastel-purple"
        />
      </l-container>

      <div class="text-lg">Disclaimer</div><br>
      <div class="text-sm">
          NILU makes no warranty of any kind, express or implied, concerning the provided data and information, including but not limited to any warranties of merchantability or fitness for any particular purpose. NILU assumes no responsibility or legal liability concerning the data’s accuracy, reliability, completeness, timeliness, or usefulness.  
        </div>
      <br/>
      <div class="text-sm ">
          NILU accepts no responsibility for any loss or damage that may result from accessing or reliance on the content of the website and hereby disclaim any or all liability with respect to acts or omissions made by users/clients on the basis of the content on the website. 
        </div> 
      <br/><br/>
      <div class="text-lg">Credit</div><br>
      <div class="text-sm">
        The maps make partial use of open uEMEP data, whose provision by MET Norway is gratefully acknowledged.
      </div>
    </div>
  </template>
  
  <script>
  import ContextMenu from "./context.menu";
  
  export default {
    name: "about",
  };
  </script>
  
  
  
  